import { render, staticRenderFns } from "./system.vue?vue&type=template&id=3f3dd8ea&"
import script from "./system.vue?vue&type=script&lang=js&"
export * from "./system.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports